/**
 * An answer arrives in pieces, so a bold run can be open when the text is drawn: «…к **Солнцу в Водо».
 * Markdown shows such an unclosed `**` as two raw asterisks. This closes the run for display only, so the
 * words are already bold while they are being typed; the stored message is never changed.
 *
 * Only the last line matters: bold never spans lines, and every earlier line is complete.
 */
export function closePartialBold(text: string): string {
  const nl = text.lastIndexOf('\n');
  const head = text.slice(0, nl + 1);
  let line = text.slice(nl + 1);

  // Half of a marker has arrived («…к *»): hide it until the next piece says what it is.
  // A list bullet («* пункт») is a single asterisk followed by a space, so it is not touched.
  if (/(^|[^*])\*$/.test(line)) line = line.slice(0, -1);

  const markers = line.match(/\*\*/g)?.length ?? 0;
  if (markers % 2 === 0) return head + line;

  const open = line.lastIndexOf('**');
  const inside = line.slice(open + 2);
  // Nothing typed after the opener yet: drop the opener instead of showing it.
  if (inside.trim() === '') return head + line.slice(0, open);
  // Markdown does not close bold after a space: close before the trailing spaces.
  const trimmed = inside.replace(/\s+$/, '');
  return head + line.slice(0, open) + '**' + trimmed + '**' + inside.slice(trimmed.length);
}
